import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Project from '@/components/Project'
import Page404 from '@/components/Page404'



Vue.use(Router);

export default new Router({
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/index.html',
      component: Home,
      alias: ''
    },
    {
      path: '/404',
      name: 'page404',
      component: Page404,
    },
    {
      path: '/:id',
      name: 'Project',
      component: Project
    },
    {
      path: '/:id/index.html',
      component: Project,
      redirect: '/:id'
    },

    {
      path: '*',
      redirect: '/404',
    },



  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js